import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

const chequeDetail = defineAsyncComponent(() => import('@/views/deposit/cheque/ChequeDetail.vue'));
const depositDetail = defineAsyncComponent(() => import('@/views/deposit/deposit/DepositDetail.vue'));
const jetpayTransferPopup = defineAsyncComponent(() => import('@/views/deposit/jetpay/JetpayTransferPopup.vue'));
const jetpayAccountMismatchPopup = defineAsyncComponent(() => import('@/views/deposit/jetpay/JetpayAccountMismatchPopup.vue'));
const jetpayInsufficientBalancePopup = defineAsyncComponent(() => import('@/views/deposit/jetpay/JetpayInsufficientBalancePopup.vue'));

export function registerDeposit(app) {
  const registerConfig = {
    ChequeDetail: chequeDetail,
    DepositDetail: depositDetail,
    JetpayTransferPopup: jetpayTransferPopup,
    JetpayAccountMismatchPopup: jetpayAccountMismatchPopup,
    JetpayInsufficientBalancePopup: jetpayInsufficientBalancePopup,
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'deposit');
}